const getAttendanceStatus = (id) => {
  if (id === -1) return "Absent"
  if (id === 1) return "Attended"
  return "Unknown"
}

export default getAttendanceStatus
